const ALO_SESSION_UTM_PARAMS = 'alo_session_utm_parameters';

export const storeSessionUtmParameters = () => {
  const utmParams: Record<string, string> = {};
  const searchParams = new URLSearchParams(window.location.search);

  searchParams.forEach((value, key) => {
    if (key.toLowerCase().startsWith('utm_')) {
      utmParams[key] = value;
    }
  });

  if (Object.keys(utmParams).length > 0) {
    try {
      sessionStorage.setItem(ALO_SESSION_UTM_PARAMS, JSON.stringify(utmParams));
    } catch (err) {
      // try catch-ed because theoretically it's possible for JSON.stringify to throw an error
      // in practice for any standard use case this should not happen
      console.error('Error storing UTM parameters in sessionStorage:', err);
    }
  }
};

export const getSessionUtmParameters = (): Record<string, string> => {
  const utmParamsString = sessionStorage.getItem(ALO_SESSION_UTM_PARAMS);
  const allUtmParams = utmParamsString ? JSON.parse(utmParamsString) : {};

  return {
    utm_source: allUtmParams.utm_source ?? null,
    utm_medium: allUtmParams.utm_medium ?? null,
    utm_campaign: allUtmParams.utm_campaign ?? null,
  };
};
